import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import { daysJsFormat } from "./constants";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import frFR from "antd/locale/fr_FR";
import itIT from "antd/locale/it_IT"; // Importer la locale française

export const tz = "Europe/Zurich";

const utcFix = (option, dayjsClass) => {
  dayjsClass.prototype.valueOf = function() {
    const addedOffset = !this.$utils().u(this.$offset)
      ? this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset())
      : 0;
    return this.$d.valueOf() - addedOffset * 60 * 1000;
  };
};

const language =
  localStorage.getItem("i18nextLng") || process.env.DEFAULT_LANGUAGE || "fr";

if (language === "it") {
  console.debug("Setting language to Italian");
  dayjs.locale("it");
} else {
  dayjs.locale("fr");
}

dayjs.extend(utcFix);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault(tz);

dayjs.prototype["customFormat"] = function(format = "") {
  return this.format(format);
  // return this.tz(tz).format(format);
};

// Here was the trick ! it look like there is a major bug on the format
// the trick is to get the direct date from the object
// https://github.com/wellcomecollection/wellcomecollection.org/blob/32af11a4169a0a91ff3e1efd2cf2bf919d61fb90/common/utils/dates.ts#L37-L45
// https://github.com/iamkun/dayjs/pull/1448
dayjs.prototype["custom$d"] = function(format = "") {
  return this.$d;
  // return this.tz(tz).format(format);
};

export const generalFormatAntd = d => {
  return d.customFormat(daysJsFormat.full);
};

export const dayFormatAntd = d => {
  return d.customFormat(daysJsFormat.day);
};

export const dateCustomFormat = d => {
  return d.customFormat(daysJsFormat.day);
};

export default d => dayjs(d).tz(tz);
